"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./BrowserSupportBanner.scss");
var _useBrowser = _interopRequireDefault(require("./useBrowser"));
var _Alert = _interopRequireDefault(require("../Alert/Alert"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const BrowserSupportBanner = _ref => {
  let {
    content
  } = _ref;
  const {
    activeBanner,
    removeAlert
  } = (0, _useBrowser.default)(content);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: activeBanner ? "browser-support-banner" : " browser-support-banner remove-alert"
  }, /*#__PURE__*/_react.default.createElement(_Alert.default, {
    text: content.text,
    onClick: () => removeAlert(),
    type: content.type || "default"
  }));
};
var _default = BrowserSupportBanner;
exports.default = _default;